import React from 'react';
import { ChipProps } from '@mui/material';
import { IconButton } from 'components/Buttons/IconButton';
import { CustomIcon } from 'components/CustomIcon';
import { IconType } from 'components/CustomIcon/CustomIcon.config';
import * as Styled from './MBChip.styles';

export interface MBChipProps {
  startIcon?: IconType;
  removeIcon?: IconType;
  labelText: string;
  isSelected?: boolean;
  color?: ChipProps['color'];
  variant?: ChipProps['variant'];
  size?: ChipProps['size'];
  clickable?: ChipProps['clickable'];
  disabled?: ChipProps['disabled'];
  children?: ChipProps['children'];
  fontWeight?:
    | 'bold'
    | 'unset'
    | 'bolder'
    | 'lighter'
    | 'normal'
    | 'inherit'
    | 'initial'
    | 'revert';
  fontSize?: string | number;
  onClick?: ChipProps['onClick'];
  onDelete?: ChipProps['onDelete'];
  isShowRightIconOnHover?: boolean;
  id?: string;
}

const MBChip: React.FC<MBChipProps> = ({
  startIcon,
  removeIcon,
  labelText,
  isSelected,
  color,
  variant,
  size,
  clickable,
  fontWeight = 'inherit',
  fontSize,
  disabled,
  onClick,
  onDelete,
  isShowRightIconOnHover = false,
}) => {
  const icon =
    startIcon != null ? <CustomIcon name={startIcon} dense /> : undefined;
  const deleteIcon =
    removeIcon != null ? (
      <IconButton iconName={removeIcon} dense disableRipple />
    ) : undefined;

  return (
    <Styled.ChipWrapper
      fontSize={fontSize}
      fontWeight={fontWeight}
      selected={isSelected}
      icon={icon}
      color={color}
      variant={variant}
      size={size}
      clickable={clickable}
      deleteIcon={deleteIcon}
      label={labelText}
      disabled={disabled}
      onClick={onClick}
      isShowRightIconOnHover={isShowRightIconOnHover}
      onDelete={onDelete}
    />
  );
};

export default MBChip;
